<main class="esf-main-content esf-main-content--has-sidebar -has-transition -width-max" [class.-is-open]="sidebarService.isOpened">
  <div class="esf-container main-content">

    <h1 class="esf-heading esf-heading--page">
      <span class="esf-action-heading__text" i18n='@@importDataComponent.heading.importData'>Import history</span>
    </h1>

    <app-paginated-table [columns]="columns"
                         [keys]="keys"
                         [data]="importHistory"
                         [actionButtons]="actionButtons"
                         (rowButtonClickEvent)="actionButtonClicked($event)"

                         [baseApi]="baseApi"
                         [customQueries]="customQueries"
                         (dataFetchedEmitter)="createImportHistoryList($event)"

                         [emptyStateText]="i18nEmptyState"
                         [emptyStateIcon]="'#esf-icon-bell-32'">

    </app-paginated-table>

  </div>
</main>
